// import { Directive } from '@angular/core';

// @Directive({
//   selector: '[appRegisterConfirmPassword]'
// })
// export class RegisterConfirmPasswordDirective {

//   constructor() { }

// }

import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[validateEquall][formControlName],[validateEquall][formControl],[validateEquall][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => RegisterConfirmPasswordDirective), multi: true }
    ]
})
export class RegisterConfirmPasswordDirective implements Validator {
    constructor(@Attribute('validateEquall') public validateEquall: string,
    @Attribute('reverse') public reverse: string) {
    }

    private get isReverse() {
        if (!this.reverse) return false;
        return this.reverse === 'true' ? true: false;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        // self value
        let v = c.value;

        // control vlaue
        let e = c.root.get(this.validateEquall);

        // value not equal
        if (e && v !== e.value && !this.isReverse) {
            return {
                validateEquall: false
            }
        }

        // value equal and reverse
        if (e && v === e.value && this.isReverse) {
            delete e.errors['validateEquall'];
            if (!Object.keys(e.errors).length) e.setErrors(null);
        }

        // value not equal and reverse
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({ validateEquall: false });
        }

        return null;
    }
}
